module.exports = __webpack_public_path__ + "img/img-img-mype-p-coin@3x.6d99ceeb.png";